module.exports = __webpack_public_path__ + "static/img/book-a.04715ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book-a.jpg
// module id = hD+B
// module chunks = 1